export interface SupervisorObject {
    LoginID: number;
    LoginName: string;
    LifetimeCoins: number;
    AvailableCoins: number;
    LifetimeXp: number;
    CurrentXp: number;
    ImageID: number;
    ActiveGameCount: number;
    AvailableGameCount: number;
    ManualGameCount: number;
    TeamName: string;
    ImageType: number;
    Badges: number;
    GroupName: string;
}

export interface SupervisorDataObject {
    status: string;
    message: string,
    execution_time_utc: string,
    warnings: string[],
    status_code: number,
    data : SupervisorObject[]
}

export class SupervisorDataByLogin {
    data: SupervisorObject[];
}

export enum ViewType {
    cardView = 0,
    seeMore = 1
}
